import * as React from 'react';
import * as Tgcc from '../tgccGlobal';
import * as Request from '../tgccRequest';
import Radium, { StyleRoot } from 'radium';
import {connect} from 'react-redux';
import {CSSProperties} from 'react';
import {BulletLine} from '../Components/BulletLine';
import {RealCampusDashboardCard} from './RealCampusDashboardCard';


const containerStyle: CSSProperties = {
    display: 'flex',
    flexDirection: 'column',
    padding: '15px 15px 5px 15px',
    overflow: 'hidden',
    height: '100%',
    alignItems:'center'
}

const inputStyle: CSSProperties = {
    width: '225px',
    height:'40px',
    textAlign: 'left',
    margin: '5px',
    fontSize: '14px',
    lineHeight: '3.0em',
    fontFamily:'AveriaSerifLightItalic',
    backgroundColor:'white',
    flex:2,
    border:'1px solid grey',
    ':focus' : {
        outline:'none'
    }
}
const labelStyle: CSSProperties = {
    fontFamily:'Reitam',
    flex:1,
    color:'rgba(66, 66, 66, 0.8)'
}

const changeStyle: CSSProperties = {
    width: '225px',
    height:'40px',
    textAlign: 'center',
    margin: '35px auto',
    fontSize: '14px',
    lineHeight: '3.0em',
    fontFamily:'Reitam',
    color:'white',
    backgroundColor:'#5E6A74',
    cursor:'pointer'
}

const div: CSSProperties = {
    width:'75%',
    display:'flex',
    justifyContent:'flex-end',
    alignItems:'center'
}



let btnStyle = Object.assign({}, Tgcc.Styles.grayButton, {margin: 'auto 0px', height: '16px', fontSize: '12px', lineHeight: '16px', width:'100px', alignSelf:'center'});
let btnDisabledStyle = Object.assign({}, btnStyle, {color: 'rgba(99,99,99,0.3)'});



export class _RealCampusPasswordCard extends React.Component<Tgcc.BaseProps, any>{
    
    state = { 
        error: null, 
        isWaiting: false,
        currentPassword: null,
        newPassword: null,
        confirmPassword: null
    };

    okToUpdate = () => {
        if(!this.state.currentPassword || this.state.currentPassword.length < 6){
            return false;
        }
        if(!this.state.newPassword || this.state.newPassword.length < 6){
            return false;
        }
        if(!this.state.confirmPassword || this.state.confirmPassword.length < 6){
            return false;
        }
        if(this.state.newPassword != this.state.confirmPassword){
            return false;
        }
        return true;
    }

    doUpdate = () => {
        if(this.props.state.LoginData){
            this.setState({isWaiting: true});
            Request.changeUserPassword(this.props.state.LoginData, this.state.currentPassword, this.state.newPassword, this.changed, this.error);
        }
    }
    
    changed = () => {
        this.setState({error: "Password changed", isWaiting: false, currentPassword: "", newPassword: "", confirmPassword: ""})
    }

    error = (err: string) => {
        if(err.toString().toUpperCase() == "INCORRECT PASSWORD.")
            this.setState({error: "Old password is incorrect", isWaiting: false});
        else 
            this.setState({error: err, isWaiting: false});
    } 

    currentPasswordChanged = (evt: React.SyntheticEvent<HTMLInputElement>) => {
        var val = evt.currentTarget.value;
        var msg = !val || val.trim().length < 6 ? "old password too short" 
            : this.checkNewPassword(this.state.newPassword, this.state.confirmPassword);
        this.setState({ currentPassword: evt.currentTarget.value, error: msg});
    }

    checkNewPassword = (pw: string, pw2: string) => {
        if(!pw || pw.trim().length < 6)
            return "new password too short";
        if(pw != pw2)
            return "new passwords don't match";
        return null;
    }

    
    newPasswordChanged = (evt: React.SyntheticEvent<HTMLInputElement>) => {
        var pw = evt.currentTarget.value;
        var msg = this.checkNewPassword(pw, this.state.confirmPassword);
        this.setState({ newPassword: evt.currentTarget.value, error: msg});
    }

    confirmPasswordChanged = (evt: React.SyntheticEvent<HTMLInputElement>) => {
        var cpw = evt.currentTarget.value;
        var msg = this.checkNewPassword(cpw, this.state.newPassword);
        this.setState({ confirmPassword: evt.currentTarget.value, error: msg});
    }

    render(){
        var updateBtn = this.okToUpdate() ?
            <div style={changeStyle} key={1} onClick={this.doUpdate}>Change</div>
            : <div key={2} style={changeStyle}>Change</div>
        if(this.state.isWaiting)
            updateBtn = Tgcc.workingGif;

        var err = this.state.error ? <div style={Tgcc.Styles.error}>{this.state.error}</div> : null;
        
        return (
            <RealCampusDashboardCard>
                <div style={containerStyle}>
                    <div style={div}>
                        <label htmlFor="currentPassword" style={labelStyle}>Current Password:</label>        
                        <input key={100} value={this.state.currentPassword||''} style={inputStyle} type='password' name='currentPassword' placeholder="Current Password" onChange={this.currentPasswordChanged} />
                    </div>
                    <div style={div}>
                        <label htmlFor="newPassword" style={labelStyle}>New Password:</label>
                        <input key={101} value={this.state.newPassword||''} style={inputStyle} type='password' name='newPassword'  placeholder="New Password" onChange={this.newPasswordChanged} />
                    </div>
                    <div style={div}>
                        <label htmlFor="confirmPassword" style={labelStyle}>Confirm Password:</label>
                        <input key={102} value={this.state.confirmPassword||''} style={inputStyle} type='password' name='confirmPassword' placeholder="Confirm Password"  onChange={this.confirmPasswordChanged} /> 
                    </div>
                    {err}
                    {updateBtn}
                </div>
            </RealCampusDashboardCard>
        )
    }
}


const mapStateToProps = (state: Tgcc.GlobalState) => {
    return { state: state };
};
export var RealCampusPasswordCard = connect(mapStateToProps)(Radium(_RealCampusPasswordCard));